import {
  BuilderContent,
  fetchOneEntry,
  getBuilderSearchParams,
} from "@builder.io/sdk-react";

import { createFetchCacheConfig } from "@/libs/cache-config/fetch/createFetchCacheConfig";

import { env } from "../../../env";
import { BuilderModels } from "../builder.models.types";

export type FetchOneEntryParams = Parameters<typeof fetchOneEntry>;

export type FetchOneEntryQuery = FetchOneEntryParams[0]["query"];

type FetchOneEntryOptions = Omit<
  FetchOneEntryParams[0],
  "apiKey" | "locale" | "model"
> & { model: BuilderModels; locale?: string; bypassCache?: boolean };

type BuilderContentWithQuery = BuilderContent & {
  query?: FetchOneEntryQuery[];
};

export type FetchOneBuilderEntryResponse = BuilderContentWithQuery | null;

export const fetchOneBuilderEntry = async ({
  locale,
  options,
  userAttributes,
  bypassCache,
  ...restParams
}: FetchOneEntryOptions) =>
  fetchOneEntry({
    fetch: bypassCache ? undefined : fetchWithCache,
    apiKey: env.builderApiKey,
    options: {
      ...getBuilderSearchParams(options),
      cachebust: true, // intentionally disable cache
    },
    cacheSeconds: 0, // intentionally disable cache
    locale,
    userAttributes: {
      locale,
      ...userAttributes,
    },
    ...restParams,
    // Casting is needed because Builder SDK types are not fully compatible with the expected return type
    // Query is available and needed in the response
  }) as FetchOneBuilderEntryResponse;

const fetchWithCache = (input: string, init?: object | undefined) => {
  return fetch(input, {
    ...createFetchCacheConfig({ tags: ["builder-fetch-cache-tag"] }),

    ...init,
  });
};
